export const textResponseHandler = (response: Response) => {
  return response.text();
};
